import React, { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "../components/MDBox";
import MDButton from "../components/MDButton";
import MDInput from "../components/MDInput";
import MDTypography from "../components/MDTypography";

// Authentication layout components
import BasicLayout from "../components/layout/authentication/components/BasicLayout";

// Images

import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";

import formlogo from "../assets/formlogo.jpg"; 
import { changeAppToken } from "../redux/slices/applicationTokenSlice";
import { useNavigate } from "react-router-dom";
import { changeLoginData } from "../redux/slices/loginSlice";
import moment from "moment";


function Login() {
  const navigate = useNavigate();
  const reduxDispatch = useDispatch();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isForgotPass, setIsForgotPass] = useState(false);

  // Sayfa yüklendiğinde zaten giriş yapmış kullanıcıları kontrol et
  React.useEffect(() => {
    // Form kullanıcısı giriş yapmışsa, panel kullanıcısı giriş yapamaz
    const formUserToken = localStorage.getItem('formUserToken');
    const formUserData = localStorage.getItem('formUserData');
    
    if (formUserToken && formUserData) {
      try {
        const parsedUserData = JSON.parse(formUserData);
        if (parsedUserData && parsedUserData.id) {
          console.log('Form user already logged in, redirecting to user dashboard');
          navigate('/user-dashboard');
          return;
        }
      } catch (error) {
        console.error('Error parsing stored form user data:', error);
      }
    }

    // Panel kullanıcısı zaten giriş yapmışsa dashboard'a yönlendir
    const panelUserToken = localStorage.getItem('userToken');
    if (panelUserToken) {
      navigate("/");
    }
  }, [navigate]);



  const toastFunc = (message, type = "default") => {
    toast(message, {
      autoClose: true,
      position: "top-right",
      type: type,
    });
  };

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        "https://app.hhoms.com/api/panel/Users/login",
        { Email: email, Password: password },
        {
          headers: {
            ApplicationToken: "gonca",
          },
        }
      );

      const loginResp = response.data;
      const owner = loginResp.owner;

      // API yanıtını konsola yazdır (debug için)
      console.log('Login API Response:', loginResp);
      console.log('Owner data:', owner);
      console.log('Owner logoUrl:', owner.logoUrl);
      console.log('Owner companyName:', owner.companyName);

      if (owner && owner.token) {
        // Kullanıcı bilgilerini Redux store'a kaydet
        const userData = {
          id: owner.id || owner.userId || owner.user?.id, // Kullanıcı ID'sini al
          username: email,
          password: password,
          loginDate: moment().format("DD.MM.YYYY HH:mm"),
          userType: 'panelUser', // Panel kullanıcısı olduğunu belirt
          name: owner.name || owner.hotelName || owner.companyName || owner.businessName || owner.title || owner.displayName || email.split('@')[0], // Otel adını al
          companyName: owner.companyName, // Şirket adı
          logoUrl: owner.logoUrl, // Logo URL'i
          imageUrl: owner.imageUrl, // Resim URL'i
          languages: owner.languages, // Diller
          mobileLanguages: owner.mobileLanguages, // Mobil diller
          developer: owner.developer, // Developer flag
        };
        
        console.log('Created userData:', userData);
        console.log('userData logoUrl:', userData.logoUrl);
        console.log('userData companyName:', userData.companyName);
        
        reduxDispatch(changeAppToken(owner.token));
        reduxDispatch(changeLoginData(userData));

        // Panel kullanıcısı için özel localStorage anahtarları kullan
        localStorage.setItem('userToken', owner.token);
        localStorage.setItem('userType', 'panelUser');
        localStorage.setItem('userData', JSON.stringify(userData));

        // Kullanıcıyı yönlendir
        window.location.href = "/";
        toastFunc("Giriş başarılı", "success");
      } else {
        toastFunc("Giriş başarısız: Token alınamadı", "error");
      }
    } catch (error) {
      toastFunc(error.response?.data?.message || "Giriş başarısız", "error");
    }
  };

  const handleForgotPassword = async () => {
    try {
      const response = await axios.post(
        "https://app.hhoms.com/api/panel/Users/forgotPassword",
        { Email: email },
        {
          headers: {
            ApplicationToken: "gonca",
          },
        }
      );
      toastFunc(response.data.message, "success");
      setIsForgotPass(false);
    } catch (err) {
      toastFunc(err.response.data.message, "error");
    }
  };

  return (
    <BasicLayout image ={formlogo}>
      <ToastContainer />
      <Card>
        <MDBox
          variant="gradient"
          bgcolor="info"
          borderRadius="lg"
          coloredshadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
          align="center"
        >
          <img src={formlogo} alt="Form Logo" style={{ width: '300px', height: '300px', marginBottom: '-100px' }} />
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          {isForgotPass ? (
            <MDBox component="form" role="form">
              <MDBox mb={2}>
                <MDInput
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  label="Email"
                  value={email}
                  fullWidth
                />
              </MDBox>
              <MDBox mt={4} mb={1}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <MDButton
                      variant="gradient"
                      color="warning"
                      onClick={() => setIsForgotPass(false)}
                      fullWidth
                    >
                      geri dön
                    </MDButton>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <MDButton
                      variant="gradient"
                      color="info"
                      onClick={handleForgotPassword}
                      fullWidth
                    >
                      yeni şifre
                    </MDButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          ) : (
            <MDBox component="form" role="form">
              <MDBox mb={2}>
                <MDInput
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  label="Email"
                  value={email}
                  fullWidth
                />
              </MDBox>
              <MDBox mb={2}>
                <MDInput
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  label="Şifre"
                  fullWidth
                />
              </MDBox>
              <MDBox display="flex" justifyContent="flex-end">
                <MDBox display="flex" alignItems="center">
                  <u
                    style={{
                      color: "#338cec",
                      cursor: "pointer",
                    }}
                  >
                    <a
                      style={{
                        fontSize: 14,
                        color: "#338cec",
                        textDecoration: "underline",
                        cursor: "pointer",
                        userSelect: "none",
                      }}
                      onClick={() => setIsForgotPass(true)}
                    >
                      Şifreyi Yenile
                    </a>
                  </u>
                </MDBox>
              </MDBox>
              <MDBox mt={4} mb={1}>
                <MDButton
                  variant="contained"
                  color="info"
                  onClick={handleLogin}
                  fullWidth
                >
                  GİRİŞ
                </MDButton>
              </MDBox>
              
              {/* Form kullanıcısı girişi için buton */}
              <MDBox mt={2} mb={1}>
                <MDButton
                  variant="outlined"
                  color="info"
                  onClick={() => navigate('/user-login')}
                  fullWidth
                  sx={{
                    borderColor: '#4158D0',
                    color: '#4158D0',
                    '&:hover': {
                      borderColor: '#C850C0',
                      color: '#C850C0',
                      background: 'rgba(65, 88, 208, 0.05)',
                    }
                  }}
                >
                  Form Kullanıcısı Girişi
                </MDButton>
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Login;